import loader from '../assests/loader.gif';
const CustomLoader = ({ loading }) => {
    return (
        <>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    );
};
export default CustomLoader;
